import { render, staticRenderFns } from "./CredenciamentoFornecedorAcoesSolicitarCredenciamento.vue?vue&type=template&id=7af5b4a4"
import script from "./CredenciamentoFornecedorAcoesSolicitarCredenciamento.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorAcoesSolicitarCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorAcoesSolicitarCredenciamento.vue?vue&type=style&index=0&id=7af5b4a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports